import { Tabs, Tab } from '@mui/material';

/**
 *
 * @param {value} - Selected value
 * @param {handleChange} - Callback function fired when selecting a new tab value
 * @returns {JSX.Element}
 */

type TabsListPropsType = {
  tabsList: Array<{
    label: string;
    disabled?: boolean;
  }>;
  value: number;
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  handleChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
};

const TabsList = ({ tabsList, value, handleChange }: TabsListPropsType) => {
  return (
    <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
      {tabsList.map((tab) => (
        <Tab label={tab.label} disabled={tab.disabled} key={tab.label} />
      ))}
    </Tabs>
  );
};

export default TabsList;
